import React from "react";
import { useNavigate } from "react-router-dom";
import { useSEO } from "../hooks/useSEO";

const PaymentCancel = () => {
  useSEO(
    "Checkout Cancelled | Mortgage Survival Playbook 2026",
    "Your checkout was cancelled and no charge was made. Return to acquire the Mortgage Survival Playbook 2026 institutional license whenever you're ready.",
    { noindex: true }
  );
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem" }} data-testid="payment-cancel-page">
      <div className="hero-bg" />
      <div style={{ maxWidth: 520, textAlign: "center", position: "relative" }}>
        <div className="eyebrow">Checkout Cancelled</div>
        <h1 className="article-title">No charge was made</h1>
        <p style={{ color: "var(--g1)", lineHeight: 1.8, marginBottom: "1.5rem" }}>
          Your checkout was cancelled and your card was not charged. You can return and acquire the license whenever you're ready.
        </p>
        <button className="btn-gold" onClick={() => navigate("/#purchase")} data-testid="cancel-return-btn" style={{ height: 50, padding: "0 2rem" }}>
          Return to Checkout
        </button>
      </div>
    </div>
  );
};

export default PaymentCancel;
